/**Validations component for incident creation*/


// Validate latitude
export const validateLatitude = (value) => {
  // Handle undefined, null, or non-string values
  if (value === undefined || value === null) {
    return "";
  }
  // Convert to string if it's a number
  const strValue = String(value);
  // If empty string, it's optional so return no error
  if (!strValue || strValue.trim() === "") {
    return "";
  }
  // Check if it only contains numbers and decimal point

  if (!/^-?\d*\.?\d*$/.test(strValue)) {
    return "Latitude must contain only numbers and decimal point";
  }

  // Check if it has more than 14 decimal places
  const decimalPart = strValue.toString().split(".");

  if (decimalPart.length > 1 && decimalPart[1].length > 16) {
    return "Latitude can have maximum 16 digits after decimal point";
  }

  // Check if it's a valid latitude value (between -90 and 90)
  const latValue = parseFloat(strValue);

  if (isNaN(latValue) || latValue < -90 || latValue > 90) {
    return "Latitude must be a valid number between -90 and 90";
  }
  return "";
};

// Validate longitude
export const validateLongitude = (value) => {
  // Handle undefined, null, or non-string values
  if (value === undefined || value === null) {
    return "";
  }
  // Convert to string if it's a number
  const strValue = String(value);
  // If empty string, it's optional so return no error
  if (!strValue || strValue.trim() === "") {
    return "";
  }

  // Check if it only contains numbers and decimal point

  if (!/^-?\d*\.?\d*$/.test(strValue)) {

    return "Longitude must contain only numbers and decimal point";

  }

  // Check if it has more than 14 decimal places

  const decimalPart = strValue.toString().split(".");

  if (decimalPart.length > 1 && decimalPart[1].length > 16) {

    return "Longitude can have maximum 16 digits after decimal point";

  }

  // Check if it's a valid longitude value (between -180 and 180)

  const lngValue = parseFloat(strValue);

  if (isNaN(lngValue) || lngValue < -180 || lngValue > 180) {

    return "Longitude must be a valid number between -180 and 180";

  }

  return "";

};

export const validateEventName = (value) => {
  if (!value || !value.trim()) {
    return "Incident Name is required";
  }
  if (value.trim().length < 3) {
    return "Event Name must be at least 3 characters";
  }
  if (value.trim().length > 100) {
    return "Event Name must be less than 100 characters";
  }
  return "";
};

export const validateEventType = (value) => {
  if (!value || value === "" || value === "Choose incident category") {
    return "Incident Category is required";
  }
  return "";
};

export const validateIncidentDateTime = (value) => {
  if (!value) {
    return "Incident Date & Time is required";
  }

  const selectedDateTime = new Date(value);
  const currentDateTime = new Date();

  if (isNaN(selectedDateTime.getTime())) {
    return "Please enter a valid date and time";
  }

  if (selectedDateTime > currentDateTime) {
    return "Incident Date & Time cannot be in the future";
  }

  return "";
};

export const validateSeverityLevel = (value) => {
  if (!value || value === "Select Severity") {
    return "Severity Level is required";
  }
  return "";
};

export const validateResolutionTime = (value) => {
  if (!value || !value.trim()) {
    return "Estimated Resolution Time is required";
  }
  if (value.trim().length < 2) {
    return "Please provide a meaningful resolution time estimate";
  }
  return "";
};

export const validateAssignTo = (value) => {
  if (!value || value === "Select assignee") {
    return "Assign To is required";
  }
  return "";
};

export const validateBranchName = (value) => {
  if (!value || value === "") {
    return "Branch Name is required";
  }
  return "";
};

export const validateBankName = (value) => {
  if (!value || !value.trim()) {
    return "Bank Name is required";
  }
  return "";
};

export const validatePinCode = (value) => {
  if (!value || !value.trim()) {
    return "Pincode is required";
  }
  if (!/^[1-9][0-9]{5}$/.test(value)) {
    return "Pincode must be 6 digits and start with a non-zero digit";
  }
  return "";
};

export const validateCityOrMandal = (value, fieldName) => {
  if (!value || !value.trim()) {
    return `${fieldName} is required`;
  }
  if (!/^[a-zA-Z\s]+$/.test(value)) {
    return `${fieldName} must contain letters and spaces only`;
  }
  if (value.trim().length > 50) {
    return `${fieldName} must be less than 50 characters`;
  }
  return "";
};

export const validatePhoneNumber = (value) => {
  if (!value || !value.trim()) {
    return "";
  }

  if (/^[6-9]\d{9}$/.test(value)) {
    return "";
  }

  if (/^[0]\d{1,3}[-\s]?\d{6,8}$/.test(value)) {
    return "";
  }

  return "Enter a valid 10-digit mobile number or landline number (STD code + number)";
};

export const validateReporteddate = (value) => {
  if (!value) {
    return "Reported Date & Time is required";
  }

  const selectedDateTime = new Date(value);
  const currentDateTime = new Date();

  if (isNaN(selectedDateTime.getTime())) {
    return "Please enter a valid date and time";
  }

  if (selectedDateTime > currentDateTime) {
    return "Reported Date & Time cannot be in the future";
  }

  return "";
};


export const validateReportedPersonContactNo = (value) => {
  if (!value || !value.trim()) {
    return "Reporter Mobile/Landline Number is required";
  }

  if (/^[6-9]\d{9}$/.test(value)) {
    return "";
  }

  if (/^[0]\d{1,3}[-\s]?\d{6,8}$/.test(value)) {
    return "";
  }

  return "Enter a valid 10-digit mobile number or landline number (STD code + number)";
};


export const validateEmail = (value) => {
  if (!value || !value.trim()) {
    return "";
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return "Enter a valid email address (e.g., user@example.com)";
  }
  return "";
};

export const validateContactName = (value) => {
  return "";
};

export const validateWebsite = (value) => {
  if (!value || !value.trim()) {
    return "";
  }

  let urlToValidate = value;
  if (!/^https?:\/\//i.test(value)) {
    urlToValidate = "http://" + value;
  }

  try {
    const url = new URL(urlToValidate);
    if (
      !/^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(
        url.hostname
      )
    ) {
      return "Enter a valid website URL (e.g., example.com)";
    }
    return "";
  } catch (e) {
    return "Enter a valid website URL (e.g., example.com)";
  }
};

export const validateDistrict = (value) => {
  if (!value || !value.trim()) {
    return "District is required";
  }
  return "";
};

export const validateIFSCCode = (value) => {
  if (!value || !value.trim()) {
    return "IFSC Code is required";
  }
  if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)) {
    return "IFSC Code must follow the format: 4 letters, 0, and 6 alphanumeric characters";
  }
  return "";
};

export const validateAddress = (value, fieldName, isRequired = true) => {
  if (!isRequired && (!value || !value.trim())) {
    return "";
  }

  if (isRequired && (!value || !value.trim())) {
    return `${fieldName} is required`;
  }

  if (value && value.trim().length < 5) {
    return `${fieldName} must be at least 5 characters`;
  }
  if (value && value.trim().length > 100) {
    return `${fieldName} must be less than 100 characters`;
  }

  if (value && !/^[a-zA-Z0-9 ,\-/.]+$/.test(value)) {
    return `${fieldName} can only contain letters, numbers, commas, hyphens, slashes, dots, and spaces`;
  }

  return "";
};

export const validateDate = (value) => {
  if (!value) {
    return "Date is required";
  }

  const selectedDate = new Date(value);
  const currentDate = new Date();

  if (isNaN(selectedDate.getTime())) {
    return "Please enter a valid date";
  }

  selectedDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);

  if (selectedDate > currentDate) {
    return "Date cannot be in the future";
  }
  return "";
};

export const validateSource = (value) => {
  if (!value || value === "") {
    return "Source is required";
  }
  return "";
};
export const validateSlaTarget = (value) => {
  if (!value || value === "") {
    return "SLA Target is required";
  }
  return "";
};
export const validateAffectedServices = (value) => {
  if (!value || value === "") {
    return "Affected Services is required";
  }
  return "";
};
export const validateReportedPersonName = (value) => {
  if (!value || value.trim() === "") {
    return "Reported Name is required";
  }
  if (value.length > 50) {
    return "Reported Person Name must be 50 characters or less";
  }
  return "";
};

export const validateAssignedteam = (value) => {
  if (!value || value === "") {
    return "Assigned Team is required";
  }
  return "";
};
export const validateAttachments = (value) => {
  if (!value || value.length === 0) {
    return "At least one attachment is required.";
  }

  if (value.length > 3) {
    return "You can upload a maximum of 3 files.";
  }

  return "";
};

export const validateDescription = (value) => {
  if (!value || value === "") {
    return "Assigned Team is required";
  }
  return "";
};


